import { I as W, j as z } from "../jsx-runtime-ClgrxkDP.js";
import { createElement as T, isValidElement as D, Fragment as M, cloneElement as _, Children as J, useContext as U, forwardRef as X } from "react";
import { w as Y, a as K, g as Z, u as q } from "../useTranslation-De5US25M.js";
import { g as G, b as S } from "../i18nInstance-D20fwFYr.js";
function Q(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ee = {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  embed: !0,
  hr: !0,
  img: !0,
  input: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
};
const te = /* @__PURE__ */ Q(ee);
var ne = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function L(e) {
  var t = { type: "tag", name: "", voidElement: !1, attrs: {}, children: [] }, n = e.match(/<\/?([^\s]+?)[/\s>]/);
  if (n && (t.name = n[1], (te[n[1]] || e.charAt(e.length - 2) === "/") && (t.voidElement = !0), t.name.startsWith("!--"))) {
    var o = e.indexOf("-->");
    return { type: "comment", comment: o !== -1 ? e.slice(4, o) : "" };
  }
  for (var p = new RegExp(ne), s = null; (s = p.exec(e)) !== null; )
    if (s[0].trim())
      if (s[1]) {
        var i = s[1].trim(), a = [i, ""];
        i.indexOf("=") > -1 && (a = i.split("=")), t.attrs[a[0]] = a[1], p.lastIndex--;
      } else
        s[2] && (t.attrs[s[2]] = s[3].trim().substring(1, s[3].length - 1));
  return t;
}
var se = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, re = /^\s*$/, oe = /* @__PURE__ */ Object.create(null);
function V(e, t) {
  switch (t.type) {
    case "text":
      return e + t.content;
    case "tag":
      return e += "<" + t.name + (t.attrs ? function(n) {
        var o = [];
        for (var p in n)
          o.push(p + '="' + n[p] + '"');
        return o.length ? " " + o.join(" ") : "";
      }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce(V, "") + "</" + t.name + ">";
    case "comment":
      return e + "<!--" + t.comment + "-->";
  }
}
var ae = { parse: function(e, t) {
  t || (t = {}), t.components || (t.components = oe);
  var n, o = [], p = [], s = -1, i = !1;
  if (e.indexOf("<") !== 0) {
    var a = e.indexOf("<");
    o.push({ type: "text", content: a === -1 ? e : e.substring(0, a) });
  }
  return e.replace(se, function(f, c) {
    if (i) {
      if (f !== "</" + n.name + ">")
        return;
      i = !1;
    }
    var g, j = f.charAt(1) !== "/", E = f.startsWith("<!--"), b = c + f.length, x = e.charAt(b);
    if (E) {
      var y = L(f);
      return s < 0 ? (o.push(y), o) : ((g = p[s]).children.push(y), o);
    }
    if (j && (s++, (n = L(f)).type === "tag" && t.components[n.name] && (n.type = "component", i = !0), n.voidElement || i || !x || x === "<" || n.children.push({ type: "text", content: e.slice(b, e.indexOf("<", b)) }), s === 0 && o.push(n), (g = p[s - 1]) && g.children.push(n), p[s] = n), (!j || n.voidElement) && (s > -1 && (n.voidElement || n.name === f.slice(2, -1)) && (s--, n = s === -1 ? o : p[s]), !i && x !== "<" && x)) {
      g = s === -1 ? o : p[s].children;
      var m = e.indexOf("<", b), u = e.slice(b, m === -1 ? void 0 : m);
      re.test(u) && (u = " "), (m > -1 && s + g.length >= 0 || u !== " ") && g.push({ type: "text", content: u });
    }
  }), o;
}, stringify: function(e) {
  return e.reduce(function(t, n) {
    return t + V("", n);
  }, "");
} };
function R(e, t) {
  if (!e)
    return !1;
  const n = e.props ? e.props.children : e.children;
  return t ? n.length > 0 : !!n;
}
function H(e) {
  if (!e)
    return [];
  const t = e.props ? e.props.children : e.children;
  return e.props && e.props.i18nIsDynamicList ? F(t) : t;
}
function ie(e) {
  return Object.prototype.toString.call(e) !== "[object Array]" ? !1 : e.every((t) => D(t));
}
function F(e) {
  return Array.isArray(e) ? e : [e];
}
function le(e, t) {
  const n = {
    ...t
  };
  return n.props = Object.assign(e.props, t.props), n;
}
function B(e, t) {
  if (!e)
    return "";
  let n = "";
  const o = F(e), p = t.transSupportBasicHtmlNodes && t.transKeepBasicHtmlNodesFor ? t.transKeepBasicHtmlNodesFor : [];
  return o.forEach((s, i) => {
    if (typeof s == "string")
      n += `${s}`;
    else if (D(s)) {
      const a = Object.keys(s.props).length, f = p.indexOf(s.type) > -1, c = s.props.children;
      if (!c && f && a === 0)
        n += `<${s.type}/>`;
      else if (!c && (!f || a !== 0))
        n += `<${i}></${i}>`;
      else if (s.props.i18nIsDynamicList)
        n += `<${i}></${i}>`;
      else if (f && a === 1 && typeof c == "string")
        n += `<${s.type}>${c}</${s.type}>`;
      else {
        const g = B(c, t);
        n += `<${i}>${g}</${i}>`;
      }
    } else if (s === null)
      K("Trans: the passed in value is invalid - seems you passed in a null child.");
    else if (typeof s == "object") {
      const {
        format: a,
        ...f
      } = s, c = Object.keys(f);
      if (c.length === 1) {
        const g = a ? `${c[0]}, ${a}` : c[0];
        n += `{{${g}}}`;
      } else
        K("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", s);
    } else
      K("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", s);
  }), n;
}
function pe(e, t, n, o, p, s) {
  if (t === "")
    return [];
  const i = o.transKeepBasicHtmlNodesFor || [], a = t && new RegExp(i.map((m) => `<${m}`).join("|")).test(t);
  if (!e && !a && !s)
    return [t];
  const f = {};
  function c(m) {
    F(m).forEach((l) => {
      typeof l != "string" && (R(l) ? c(H(l)) : typeof l == "object" && !D(l) && Object.assign(f, l));
    });
  }
  c(e);
  const g = ae.parse(`<0>${t}</0>`), j = {
    ...f,
    ...p
  };
  function E(m, u, l) {
    const v = H(m), O = x(v, u.children, l);
    return ie(v) && O.length === 0 || m.props && m.props.i18nIsDynamicList ? v : O;
  }
  function b(m, u, l, v, O) {
    m.dummy ? (m.children = u, l.push(_(m, {
      key: v
    }, O ? void 0 : u))) : l.push(...J.map([m], (h) => {
      const r = {
        ...h.props
      };
      return delete r.i18nIsDynamicList, T(h.type, {
        ...r,
        key: v,
        ref: h.ref
      }, O ? null : u);
    }));
  }
  function x(m, u, l) {
    const v = F(m);
    return F(u).reduce((h, r, k) => {
      const A = r.children && r.children[0] && r.children[0].content && n.services.interpolator.interpolate(r.children[0].content, j, n.language);
      if (r.type === "tag") {
        let w = v[parseInt(r.name, 10)];
        l.length === 1 && !w && (w = l[0][r.name]), w || (w = {});
        const d = Object.keys(r.attrs).length !== 0 ? le({
          props: r.attrs
        }, w) : w, N = D(d), C = N && R(r, !0) && !r.voidElement, P = a && typeof d == "object" && d.dummy && !N, I = typeof e == "object" && e !== null && Object.hasOwnProperty.call(e, r.name);
        if (typeof d == "string") {
          const $ = n.services.interpolator.interpolate(d, j, n.language);
          h.push($);
        } else if (R(d) || C) {
          const $ = E(d, r, l);
          b(d, $, h, k);
        } else if (P) {
          const $ = x(v, r.children, l);
          b(d, $, h, k);
        } else if (Number.isNaN(parseFloat(r.name)))
          if (I) {
            const $ = E(d, r, l);
            b(d, $, h, k, r.voidElement);
          } else if (o.transSupportBasicHtmlNodes && i.indexOf(r.name) > -1)
            if (r.voidElement)
              h.push(T(r.name, {
                key: `${r.name}-${k}`
              }));
            else {
              const $ = x(v, r.children, l);
              h.push(T(r.name, {
                key: `${r.name}-${k}`
              }, $));
            }
          else if (r.voidElement)
            h.push(`<${r.name} />`);
          else {
            const $ = x(v, r.children, l);
            h.push(`<${r.name}>${$}</${r.name}>`);
          }
        else if (typeof d == "object" && !N) {
          const $ = r.children[0] ? A : null;
          $ && h.push($);
        } else
          b(d, A, h, k, r.children.length !== 1 || !A);
      } else if (r.type === "text") {
        const w = o.transWrapTextNodes, d = s ? o.unescape(n.services.interpolator.interpolate(r.content, j, n.language)) : n.services.interpolator.interpolate(r.content, j, n.language);
        w ? h.push(T(w, {
          key: `${r.name}-${k}`
        }, d)) : h.push(d);
      }
      return h;
    }, []);
  }
  const y = x([{
    dummy: !0,
    children: e || []
  }], g, F(e || []));
  return H(y[0]);
}
function ue(e) {
  let {
    children: t,
    count: n,
    parent: o,
    i18nKey: p,
    context: s,
    tOptions: i = {},
    values: a,
    defaults: f,
    components: c,
    ns: g,
    i18n: j,
    t: E,
    shouldUnescape: b,
    ...x
  } = e;
  const y = j || S();
  if (!y)
    return Y("You will need to pass in an i18next instance by using i18nextReactModule"), t;
  const m = E || y.t.bind(y) || ((C) => C);
  s && (i.context = s);
  const u = {
    ...G(),
    ...y.options && y.options.react
  };
  let l = g || m.ns || y.options && y.options.defaultNS;
  l = typeof l == "string" ? [l] : l || ["translation"];
  const v = B(t, u), O = f || v || u.transEmptyNodeValue || p, {
    hashTransKey: h
  } = u, r = p || (h ? h(v || O) : v || O);
  y.options && y.options.interpolation && y.options.interpolation.defaultVariables && (a = a && Object.keys(a).length > 0 ? {
    ...a,
    ...y.options.interpolation.defaultVariables
  } : {
    ...y.options.interpolation.defaultVariables
  });
  const k = a ? i.interpolation : {
    interpolation: {
      ...i.interpolation,
      prefix: "#$?",
      suffix: "?$#"
    }
  }, A = {
    ...i,
    count: n,
    ...a,
    ...k,
    defaultValue: O,
    ns: l
  }, w = r ? m(r, A) : O;
  c && Object.keys(c).forEach((C) => {
    const P = c[C];
    if (typeof P.type == "function" || !P.props || !P.props.children || w.indexOf(`${C}/>`) < 0 && w.indexOf(`${C} />`) < 0)
      return;
    function I() {
      return T(M, null, P);
    }
    c[C] = T(I);
  });
  const d = pe(c || t, w, y, u, A, b), N = o !== void 0 ? o : u.defaultTransParent;
  return N ? T(N, x, d) : d;
}
function ce(e) {
  let {
    children: t,
    count: n,
    parent: o,
    i18nKey: p,
    context: s,
    tOptions: i = {},
    values: a,
    defaults: f,
    components: c,
    ns: g,
    i18n: j,
    t: E,
    shouldUnescape: b,
    ...x
  } = e;
  const {
    i18n: y,
    defaultNS: m
  } = U(W) || {}, u = j || y || S(), l = E || u && u.t.bind(u);
  return ue({
    children: t,
    count: n,
    parent: o,
    i18nKey: p,
    context: s,
    tOptions: i,
    values: a,
    defaults: f,
    components: c,
    ns: g || l && l.ns || m || u && u.options && u.options.defaultNS,
    i18n: u,
    t: E,
    shouldUnescape: b,
    ...x
  });
}
function fe(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function(o) {
    function p(i) {
      let {
        forwardedRef: a,
        ...f
      } = i;
      const [c, g, j] = q(e, {
        ...f,
        keyPrefix: t.keyPrefix
      }), E = {
        ...f,
        t: c,
        i18n: g,
        tReady: j
      };
      return t.withRef && a ? E.ref = a : !t.withRef && a && (E.forwardedRef = a), T(o, E);
    }
    p.displayName = `withI18nextTranslation(${Z(o)})`, p.WrappedComponent = o;
    const s = (i, a) => T(p, Object.assign({}, i, {
      forwardedRef: a
    }));
    return t.withRef ? X(s) : p;
  };
}
function me({
  i18n: e,
  i18n_default_text: t,
  values: n,
  components: o,
  options: p,
  shouldUnescape: s
}) {
  return /* @__PURE__ */ z.jsx(
    ce,
    {
      defaults: t,
      i18n: e,
      values: n,
      components: o,
      tOptions: p,
      shouldUnescape: s
    }
  );
}
const ve = fe()(me);
export {
  ve as default
};
